import styled from '@emotion/styled'
import React from 'react'

import conciergeIconSrc from '../../icons/concierge-icon-white.svg'
import VideoCTA from '../video-cta'

const SectionContainer = styled('section')`
  background: ${(p) => p.theme.colors.darkTint};
  border-top: 60px solid #24906E;
  padding-bottom: 32px;
  position: relative;
  width: 100%;

  >.container {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    justify-content: space-evenly;
  }

  .intro {
    max-width: 400px;
    align-self: center;
    color: #fff;
    text-align: center;
    margin: 32px 16px;

    .heading {
      margin: 0;
    }

    .icon {
      display: block;
      margin: 0 auto;
    }

    p {
      font-size: 2rem;
      font-weight: 400;
    }

    .weDo {
      2.6rem;
    }
  }

  .servicesPanel {
    max-width: 480px;
    @media (min-width: ${(p) => p.theme.breakpoints.medium}px) {
      margin-top: -72px;
    }
    background: ${(p) => p.theme.colors.lightTint};
    border-bottom-left-radius: ${(p) => p.theme.radius}px;
    border-bottom-right-radius: ${(p) => p.theme.radius}px;
    border-bottom: 4px solid ${(p) => p.theme.colors.lightTintDarker};
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);

    header {
      // align-self: start;
      color: #fff;
      background: ${(p) => p.theme.colors.secondary};
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;

      .heading {
        font-weight: 600;
        font-size: 2.1rem;
        margin: 0;
      }
    }

    ul {
      margin: 24px 32px;
      margin-left: 34px;
      >li {
        margin:0;
        padding-left: 2px;
        &:not(:first-of-type) { margin-top: 12px; }
      }
    }
  }
`

const ConciergeServicesSection = () => (
  <SectionContainer>
    <div className="container">
      <div className="intro">
        <img
          className="icon"
          src={conciergeIconSrc}
          alt="Concierge Services icon"
          height="48"
          width="48"
          loading="lazy"
        />
        <h3 className="heading heading--h3 heading--accent">
          Concierge Services
        </h3>
        <p>
          What is too often forgotten is that getting your visa is not the end
          of the matter.
        </p>
        <p>
          There is a lot of extra help you may need in getting settled. Very few
          immigration advisors offer these services…
        </p>
        <div className="weDo heading--h4 heading--h4--accent">We do.</div>
        <VideoCTA url="https://youtu.be/M_7w4yPkEjU" />
      </div>
      <section className="servicesPanel">
        <header>
          <h4 className="heading heading--h4">
            Our concierge services include
          </h4>
        </header>
        <ul className="list">
          <li>
            Assistance in registration with the police and meeting their
            requirements
          </li>
          <li>Obtaining the biometric residence permit (BRP)</li>
          <li>Applying for a National Insurance number</li>
          <li>Explaining the position on filing a tax return</li>
          <li>Registration with a medical practitioner</li>
          <li>How to open a bank account</li>
          <li>How to rent or buy a property</li>
          <li>How to sort out a driving licence</li>
          <li>Dealing with school admissions</li>
        </ul>
      </section>
    </div>
  </SectionContainer>
)

export default ConciergeServicesSection
